
import * as React from 'react';

export default function IniciaisLetras({ frase }) {

    const gerarIniciais = (texto) => {
        const ignorar = ["de", "da", "do", "das", "dos", "a", "o", "e"];

        return texto
            ?.split(" ")
            .filter(p => p.trim() !== "" && !ignorar.includes(p.toLowerCase()))
            .map(p => p[0].toUpperCase())
            .join("") || "";
    };

    return <span>{gerarIniciais(frase)}</span>;
}
